import { auth } from "./instance";
import { NoAuthInstance } from "./instance";
import { LOGIN, FORGOT_PASSWORD } from "../utils/helper/constants/constants";

export async function sign(
  reqBody,
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  try {
    const response = await NoAuthInstance.post(LOGIN, reqBody, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function forgotPassword(
  reqBody,
  headers = { "Content-Type": "application/x-www-form-urlencoded" }
) {
  try {
    const response = await NoAuthInstance.post(FORGOT_PASSWORD, reqBody, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
}

// export const forgotPassword = async (data) =>
//   (await auth({ url: "/auth/forgot-password", data, method: "POST" })).data;

export const getSuperAdminProfile = async () =>
  (await auth({ url: "/users/profile", method: "GET" })).data;

export const createAgency = async (data) =>
  (await auth({ url: "/users/create-agency", data, method: "POST" })).data;
export const updateAgency = async (data, id) =>
  (await auth({ url: `/users/update-agency?id=${id}`, data, method: "PUT" }))
    .data;

export const createAdmin = async (data) =>
  (await auth({ url: "/users/create-admin", data, method: "POST" })).data;

export const getAllAgencies = async (data) =>
  (await auth({ url: "/users/get-agency", data, method: "GET" })).data;

export const getAllAdmins = async (data) =>
  (await auth({ url: "/users/get-admin", data, method: "GET" })).data;

export const deleteAgencyCall = async (id) =>
  (await auth({ url: `/users/delete-agency?id=${id}`, method: "DELETE" })).data;

export const deleteAdminCall = async (id) =>
  (await auth({ url: `/users/delete-admin?id=${id}`, method: "DELETE" })).data;

export const getAgencyById = async (id, params) =>
  (
    await auth({
      url: `/users/get-agency-by-id?agencyid=${id}`,
      method: "GET",
      params,
    })
  ).data;

export const createSystemUser = async (data) =>
  (await auth({ url: "/users/create-system-user", data, method: "POST" })).data;

export const getSystemUser = async () =>
  (await auth({ url: "/users/get-system-user", method: "GET" })).data;

export const getProductCategory = async () =>
  (
    await auth({
      url: "/product/get-productCategory-all",
      method: "GET",
    })
  ).data;

export const getProductAttributes = async (id, params) =>
  (
    await auth({
      url: `/product/get-Product-Attributes?productid=${id}`,
      method: "GET",
      params,
    })
  ).data;

export const deleteProductAttribute = async ({ dropdownType, AttributeId }) => {
  try {
    const response = await auth({
      url: `/product/delete-product-attribute?AttributeId=${AttributeId}`,
      method: "DELETE",
      data: { dropdownType },
    });

    return response.data;
  } catch (error) {
    console.error("Error in deleteProductAttribute:", error);
    throw error;
  }
};

export const createProduct = async (data) =>
  (
    await auth({
      url: "/product/create-product",
      method: "POST",
      data,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
  ).data;

export const updateProduct = async (data, id) =>
  (
    await auth({
      url: `/product/update-product?id=${id}`,
      method: "PUT",
      data,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
  ).data;
export const deleteProduct = async (id) =>
  (
    await auth({
      url: `/product/delete-product?productId=${id}`,
      method: "DELETE",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
  ).data;

export const getAgencyTags = async () =>
  (await auth({ url: "/product/get-tagId-by-agencyId", method: "GET" })).data;

export const deleteUserCall = async (params, id) =>
  (
    await auth({
      url: `/users/delete-system-user?id=${id}`,
      method: "DELETE",
      params,
    })
  ).data;

export const createProductCategory = async (data) =>
  (
    await auth({
      url: "/product/create-product-category",
      method: "POST",
      data,
    })
  ).data;

export const productsList = async (id, params) =>
  (
    await auth({
      url: `/product/get-products-by-categoryId`,
      method: "GET",
      params: { id, ...params },
    })
  ).data;

export const sendNotificationForProducts = async (data) => {
  return (
    await auth({
      url: "/notification/send",
      method: "POST",
      data,
    })
  ).data;
};

export const uploadTagsFile = async (data) => {
  return (
    await auth({
      url: "/product/upload-tags",
      method: "POST",
      data,
      header: { "Content-Type": "application/x-www-form-urlencoded" },
    })
  ).data;
};

export const uploadAgencyLogo = async (id, data) => {
  return (
    await auth({
      url: `users/update-agency-logo?agencyId=${id}`,
      method: "PUT",
      data,
      header: { "Content-Type": "application/x-www-form-urlencoded" },
    })
  ).data;
};

export const toggleCategoryStatus = async (id) => {
  return (
    await auth({
      url: `/product/active-inactive-category?categoryid=${id}`,
      method: "PUT",
    })
  ).data;
};

export const toggleAgencyStatus = async (id) => {
  return (
    await auth({
      url: `/users/active-inactive-agency?agencyid=${id}`,
      method: "PUT",
    })
  ).data;
};

export const activateAgency = async (params) => {
  return (
    await auth({
      url: "/users/active-inactive-agency",
      method: "PUT",
      params,
    })
  ).data;
};

export const createBatch = async (data) =>
  (await auth({ url: "/product/create-batch", data, method: "POST" })).data;

export const sendNotification = async (data) =>
  (await auth({ url: "notification/send", data, method: "POST" })).data;

export const addAttribute = async (data, id) =>
  (
    await auth({
      url: `/product/create-product-attributes?productId=${id}`,
      data,
      method: "POST",
    })
  ).data;

export const getProfile = async (params) =>
  (await auth({ url: "/users/profile", method: "GET", params })).data;

export const getProfileSuperAdmin = async (params) =>
  (await auth({ url: "/users/profile", method: "GET", params })).data;
